import { motion, AnimatePresence } from 'framer-motion';
import { Phone, Video, PhoneOff } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { getInitials } from '@/lib/utils';

export const IncomingCallDialog = ({ 
  isOpen, 
  callerInfo, 
  callType,
  onAccept, 
  onReject 
}) => {
  if (!isOpen) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0, y: -100 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -100 }}
        className="fixed top-4 left-4 right-4 z-[9999] max-w-md mx-auto"
      >
        <div className="bg-slate-900 rounded-2xl shadow-2xl overflow-hidden">
          {/* Animated background */}
          <div className="absolute inset-0 overflow-hidden">
            <motion.div
              animate={{ 
                scale: [1, 1.5, 1],
                opacity: [0.1, 0.2, 0.1]
              }}
              transition={{ repeat: Infinity, duration: 2 }}
              className="absolute inset-0 bg-emerald-500 rounded-full blur-3xl"
              style={{ transform: 'translate(-50%, -50%)', left: '50%', top: '50%' }}
            />
          </div>

          <div className="relative p-6">
            <div className="text-center mb-6">
              <motion.div
                animate={{ scale: [1, 1.05, 1] }}
                transition={{ repeat: Infinity, duration: 1.5 }}
              >
                <Avatar className="h-20 w-20 mx-auto border-4 border-emerald-500/30">
                  <AvatarImage src={callerInfo?.avatar} />
                  <AvatarFallback className="bg-slate-700 text-white text-2xl">
                    {getInitials(callerInfo?.username)}
                  </AvatarFallback>
                </Avatar>
              </motion.div>
              
              <h3 className="text-white text-xl font-semibold mt-4">
                {callerInfo?.username}
              </h3>
              <p className="text-emerald-400 text-sm mt-1">
                {callType === 'video' ? 'Videoanruf' : 'Audioanruf'}
              </p>
            </div>

            <div className="flex items-center justify-center gap-6">
              <motion.div whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.95 }}>
                <Button
                  size="lg"
                  onClick={onReject}
                  className="h-14 w-14 rounded-full bg-red-500 hover:bg-red-600"
                  data-testid="incoming-reject-btn"
                >
                  <PhoneOff className="w-6 h-6 text-white" />
                </Button>
              </motion.div>

              <motion.div whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.95 }}>
                <Button
                  size="lg"
                  onClick={onAccept}
                  className="h-14 w-14 rounded-full bg-emerald-500 hover:bg-emerald-600"
                  data-testid="incoming-accept-btn"
                >
                  {callType === 'video' ? (
                    <Video className="w-6 h-6 text-white" />
                  ) : (
                    <Phone className="w-6 h-6 text-white" />
                  )}
                </Button>
              </motion.div>
            </div>
          </div>
        </div>
      </motion.div>
    </AnimatePresence>
  );
};

export default IncomingCallDialog;
